import { render, staticRenderFns } from "./attachments-list.vue?vue&type=template&id=2194d98f&scoped=true&"
import script from "./attachments-list.vue?vue&type=script&lang=js&"
export * from "./attachments-list.vue?vue&type=script&lang=js&"
import style0 from "./attachments-list.vue?vue&type=style&index=0&id=2194d98f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194d98f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
